import { useMemo } from 'react';
import { useAuth } from '../AuthContext';
import { useAccounts } from '../lib/useAccounts';
import { useWorkflow } from '../WorkflowContext';
import { followUps, reorderCandidates } from '../lib/salesData';
import { tasksToEvents, followUpsToEvents, reordersToEvents, meetingsToEvents } from '../lib/calendarData';
import MonthCalendar from '../components/MonthCalendar';

export default function Calendar() {
  const { demo } = useAuth();
  const wf = useWorkflow();
  const { data } = useAccounts(demo);

  const events = useMemo(() => {
    const accounts = data?.accounts ?? [];
    return [
      ...tasksToEvents(wf.tasks),
      ...followUpsToEvents(followUps(accounts)),
      ...reordersToEvents(reorderCandidates(accounts)),
      ...meetingsToEvents(wf.events),
    ];
  }, [wf.tasks, wf.events, data]);

  return (
    <>
      <div className="page-head">
        <div>
          <div className="page-title">Shared Calendar</div>
          <div className="page-sub">Tasks &amp; deadlines, quote follow-ups, sales meetings, and reorder windows — synced two-way with Google Calendar.</div>
        </div>
        <div className="global-actions">
          <button className="btn small" onClick={wf.addCalendarDemo}>＋ Demo event</button>
        </div>
      </div>
      <div className="card">
        <div className="card-body"><MonthCalendar crmEvents={events} /></div>
      </div>
    </>
  );
}
